import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminSocialMediaUpdate from "../../../../views/admin/cms/socialMedia/AdminSocialMediaUpdate";

const AdminSocialMediaUpdatePage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminSocialMediaUpdate />
      <AdminFooter />
    </div>
  );
};

export default AdminSocialMediaUpdatePage;